export default __webpack_public_path__ + "static/media/file.ab84d171.svg";